import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { ReactComponent as Franchise } from "../../Global Icons/Franchise.svg";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import TextInput from "../../Global Functions/textInput";
import TwoButtons from "../../Global Functions/buttons";
import { addRewardPoints } from "../../Redux/Actions/rewardsAction"; 
import { useNavigate } from "react-router-dom";

const AddRewardPoints = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formState, setFormState] = useState({
    min_value: "",
    max_value: "",
    reward_points: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (
      formState.min_value === "" ||
      formState.max_value === "" ||
      formState.reward_points === ""
    ) {
      return toast.error("Please fill all required fields.");
    }
    if (Number(formState.min_value) >= Number(formState.max_value)) {
      return toast.error("Min value must be less than max value.");
    }
    const rewardPointsValue = Number(formState.reward_points);
    if (!Number.isInteger(rewardPointsValue) || rewardPointsValue <= 0) {
      return toast.error(
        "Reward Points must be a positive integer (no decimals, no zero)."
      );
    }

    const payload = {
      min_value: Number(formState.min_value),
      max_value: Number(formState.max_value),
      reward_points: Number(formState.reward_points),
    };

    try {
      const response = await dispatch(addRewardPoints(payload));
      if (
        response &&
        (response.statusCode === 200 || response.status === "success")
      ) {
        // toast.success("Reward points added successfully!");
        navigate("/rewards");
      } else {
        toast.error(response.message || "Failed to add reward points");
      }
    } catch {
      toast.error("Error adding reward points");
    }
  };

  return (
    <MainLayout>
      <div className="franchise-form-container">
        <div className="franchise-form-wrapper franchise-card">
          <div className="franchise-card-content">
            <div className="franchise-header">
              <div className="franchise-header-icon">
                <Franchise />
              </div>
              <h1>Add Reward Points</h1>
            </div>

            <div className="form-section">
              <TextInput
                label="Minimum Value"
                name="min_value"
                type="number"
                value={formState.min_value}
                onChange={handleChange}
                required
                inputClass="form-input"
                labelClass="form-label"
              />
            </div>

            <div className="form-section">
              <TextInput
                label="Maximum Value"
                name="max_value"
                type="number"
                value={formState.max_value}
                onChange={handleChange}
                required
                inputClass="form-input"
                labelClass="form-label"
              />
            </div>

            <div className="form-section">
              <TextInput
                label="Reward Points"
                name="reward_points"
                type="text"
                value={formState.reward_points}
                onChange={handleChange}
                inputMode="numeric"
                pattern="^[1-9][0-9]*$"
                onInput={(e) => {
                  let val = e.target.value.replace(/[^0-9]/g, ""); // Remove non-digits
                  val = val.replace(/^0+/, ""); // Remove leading zeros
                  setFormState((prev) => ({ ...prev, reward_points: val }));
                }}
                required
                inputClass="form-input"
                labelClass="form-label"
              />
            </div>

            {/* <div className="form-section">
              <label className="form-label" htmlFor="status_select">
                Status <span style={{ color: "red" }}>*</span>
              </label>
              <select
                id="status_select"
                name="status"
                value={formState.status}
                onChange={handleChange}
                className="form-input"
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div> */}

            <div className="form-navigation">
              <button type="button" onClick={() => navigate("/rewards")}>
                Cancel
              </button>
              <TwoButtons onClick2={handleSubmit} buttonHead2="Save" />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddRewardPoints;
